import React, { Component } from 'react';

import { Alert, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material';

import { VARIANT_OF_REFUND_ALL, VARIANT_OF_REFUND_PARTIAL } from '../../consts/refund';

import CustomRefundVariant from './CustomRefundVariant';
import FullRefundVariant from './FullRefundVariant';

export default class LateChangeOfMindContainer extends Component {
  render() {
    return (
      <Stack id="LateChangeOfMindContainer" spacing={3}>
        <Stack spacing={2}>
          <RadioGroup
            row
            name="variant_of_refund"
            value={this.props.refund.variant_of_refund ?? ''}
            onChange={this.props.handleVariantChange}
          >
            <FormControlLabel
              value={VARIANT_OF_REFUND_ALL}
              control={<Radio inputProps={{ 'data-cy': 'Full Refund With Fee' }} />}
              label="Full refund with Fee"
            />
            <FormControlLabel
              value={VARIANT_OF_REFUND_PARTIAL}
              control={<Radio inputProps={{ 'data-cy': 'Custom Refund' }} />}
              label="Custom Refund"
              disabled={this.props.refund.missing_cost_price_data}
            />
          </RadioGroup>
          {this.props.refund.missing_cost_price_data && (
            <Alert severity="error">Cost price data is missing, unable to perform a custom refund</Alert>
          )}
        </Stack>

        {this.props.refund.variant_of_refund == VARIANT_OF_REFUND_ALL && (
          <FullRefundVariant
            handleFlagChange={this.props.handleFlagChange}
            surchargeInfo={this.props.surchargeInfo}
            handleTmpChange={this.props.handleTmpChange}
            tmpValue={this.props.tmpValue}
            isActive={this.props.refund.variant_of_refund == VARIANT_OF_REFUND_ALL}
            refund={this.props.refund}
            with_fee={true}
          />
        )}

        {this.props.refund.variant_of_refund == VARIANT_OF_REFUND_PARTIAL && (
          <CustomRefundVariant
            handleValueChange={this.props.handleValueChange}
            handleFlagChange={this.props.handleFlagChange}
            handleTmpChange={this.props.handleTmpChange}
            tmpValue={this.props.tmpValue}
            itemRefund={this.props.itemRefund}
            itemRefundOriginal={this.props.itemRefundOriginal}
            isActive={this.props.refund.variant_of_refund == VARIANT_OF_REFUND_PARTIAL}
            refund={this.props.refund}
          />
        )}
      </Stack>
    );
  }
}
